module.exports = __webpack_public_path__ + "media/packs/images/flags/GA-b5f3f2c2a76794b2bd091888814ec5de.png";